import React from 'react';
import { JournalEntryStatus } from '../../../../types/accounting';
import { formatJournalStatusLabel } from './journalForm';

export function JournalEntryStatusBadge({
  status,
}: {
  status: JournalEntryStatus;
}) {
  const className = {
    draft: 'bg-amber-50 text-amber-700',
    posted: 'bg-emerald-50 text-emerald-700',
    reversed: 'bg-blue-50 text-blue-700',
    voided: 'bg-gray-100 text-gray-700',
  }[status];

  return (
    <span
      className={`inline-flex rounded-full px-2.5 py-1 text-xs font-semibold ${className}`}
    >
      {formatJournalStatusLabel(status)}
    </span>
  );
}
